import router from "./router";
import store from "./store";
// import { Message } from "element-ui";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";
// import { isRelogin } from "@/utils/request";

NProgress.configure({ showSpinner: false });

const whiteList = ["/login"];
const passwordAllowList = ["/activationList", "/codelist"]; // 允许免输入密码的路径
router.beforeEach((to, from, next) => {
  document.title = "莱嗨";
  NProgress.start();
  if (getToken()) {
    // to.meta.title && store.dispatch("settings/setTitle", to.meta.title);
    /* has token*/
    // 先处理密码缓存逻辑
    if (!passwordAllowList.includes(to.path)) {
      // 进入非允许页面，清除密码缓存
      sessionStorage.removeItem("passwordVerified");
    }
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      // console.log("to :>> ", to);
      store.dispatch("dict/loadDictDatas", "language");
      if (to.meta.parent === "viewpager") {
        store.dispatch("dict/loadDictDatas", "jump_type");
        store.dispatch("dict/loadDictDatas", "banner_position");
      }
      if (to.meta.parent === "news") {
        store.dispatch("dict/loadDictDatas", "news_type");
      }
      if (to.meta.parent === "information") {
        store.dispatch("dict/loadDictDatas", "jump_type");
      }
      if (to.meta.parent === "goods") {
        store.dispatch("dict/loadDictDatas", "postage_type");
      }
      if (to.meta.parent === "order") {
        store.dispatch("dict/loadDictDatas", "order_status");
      }
      if (to.meta.parent === "aftersale") {
        store.dispatch("dict/loadDictDatas", "apply_refund_status");
      }
      if (to.meta.parent === "circle") {
        store.dispatch("dict/loadDictDatas", "content_review_status");
      }
      if (to.meta.parent === "device") {
        store.dispatch("dict/loadDictDatas", "quality_testing_status");
        store.dispatch("dict/loadDictDatas", "create_status");
      }
      if (to.meta.parent === "versions") {
        store.dispatch("dict/loadDictDatas", "system_type");
        store.dispatch("dict/loadDictDatas", "update_type");
        store.dispatch("dict/loadDictDatas", "manufacturer");
      }
      // console.log(to.meta.parent);
      if (to.meta.parent === "game") {
        store.dispatch("dict/loadDictDatas", "screen_orientation");
        store.dispatch("dict/loadDictDatas", "web_game_type");
      }

      if (to.meta.parent === "romlist") {
        store.dispatch("dict/loadDictDatas", "rom_type");
        store.dispatch("dict/loadDictDatas", "rom_game_type");
        store.dispatch("dict/loadDictDatas", "rom_supported_platform");
        store.dispatch("dict/loadDictDatas", "status");
      }

      next();
      // }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      const redirect = encodeURIComponent(to.fullPath); // 编码 URI，保证参数跳转回去后，可以继续带上
      next(`/login?redirect=${redirect}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
